<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToCollapse'
});
</script>
<template>
	<div class="to-collapse" :flex="flex ? flex : null" :class="setClass">
		<slot></slot>
	</div>
</template>
<script lang="ts" setup>
import { Ref, computed, onMounted, provide, ref, watch } from 'vue'



export interface Props {
	mode?: string
	modeValue?: string | string[]
	expand?: boolean
	accordion?: boolean
	flex?: boolean
}
export interface IStore {
	addChild: (name: string) => void
	allChildren: Ref<any[], any[]>
	activeValue: Ref<any[], any[]>
	setActiveValues: (name) => void
	pProps: Props
}

const props = withDefaults(defineProps<Props>(), {
	mode: 'default',
	modeValue: '',
	expand: false,
	accordion: false,
	flex: false
})

const emit = defineEmits(['change', 'update:modelValue'])

const allChildren = ref([])
const activeValue = ref([])

watch(
	() => activeValue.value,
	val => {
		if (props.accordion) {
			emit('change', val[0])
			emit('update:modelValue', val[0])
		} else {
			emit('change', val)
			emit('update:modelValue', val)
		}
	},
	{
		deep: true
	}
)
function addChild(value) {
	allChildren.value.push(value)
}
function setActiveValues(value) {
	if (activeValue.value.includes(value)) {
		let idx = activeValue.value.findIndex(item => item === value)
		idx !== -1 && activeValue.value.splice(idx, 1)
	} else {
		if (props.accordion) {
			activeValue.value = []
			activeValue.value.push(value)
		} else {
			activeValue.value.push(value)
		}
	}
}

provide<IStore>('Store', {
	addChild,
	allChildren,
	activeValue,
	setActiveValues,
	pProps: props
})

const setClass = computed(() => {
	let arr = []
	if (props.mode) {
		arr.push(`mode-${props.mode}`)
	}
	return arr
})

onMounted(() => {
	if (props.expand && !props.accordion) {
		activeValue.value = allChildren.value
	}
})
</script>
